(function () {
  document.addEventListener("shopify:section:load", function () {
    const slider = new Swiper(".js-media-list", getSliderSettings);

    const subSlider = new Swiper(
      ".js-media-sublist",
      getSubSliderProductSettings
    );

    setTimeout(function () {
      slider.update();
      subSlider.update();
    }, 100);
  });

// Product color behaviour
// Ensure that users can change other options (Availability, Size) even if there are no matching color choices
document.addEventListener('DOMContentLoaded', function() {
  const stockRadios = document.querySelectorAll('input[name="Availability"]'); // Radio buttons for stock
  const colorRadios = document.querySelectorAll('input[name*="Color"]'); // Radio buttons for color
  const sizeRadios = document.querySelectorAll('input[name="Size"]'); // Radio buttons for size
 

  if (stockRadios.length && colorRadios.length && sizeRadios.length) {
    // Add event listener to each stock radio button
    stockRadios.forEach(function(stockRadio) {
      stockRadio.addEventListener('change', function() {
        if (this.checked) {
          const selectedStock = this.value;
          const selectedSize = document.querySelector('input[name="Size"]:checked').value;
           const variantScript = document.querySelector('variant-radios script[type="application/json"]');
    const variants = JSON.parse(variantScript.textContent);
          // Find first available color for this stock type
          for (let colorRadio of colorRadios) {
            if (colorRadio.value && colorRadio.value !== '') {
              // Check if this stock + color combination exists
              const variantExists = checkVariantExists(variants, selectedSize, selectedStock, colorRadio.value);
              if (variantExists) {
                // Select this color radio button
                colorRadio.checked = true;
                // Trigger change event to update product
                colorRadio.dispatchEvent(new Event('change'));
                break;
              }
            }
          }
        }
      });
    });

     // And Add event listener to each size radio button
    sizeRadios.forEach(function(sizeRadios) {
      sizeRadios.addEventListener('change', function() {
        if (this.checked) {
          const selectedSize = this.value;
          const selectedStock = document.querySelector('input[name="Availability"]:checked').value;
           const variantScript = document.querySelector('variant-radios script[type="application/json"]');
    const variants = JSON.parse(variantScript.textContent);
          // Find first available color for this stock type
          let noVariant = true
          for (let colorRadio of colorRadios) {
            if (colorRadio.value && colorRadio.value !== '') {
              // Check if this stock + color combination exists
              const variantExists = checkVariantExists(variants, selectedSize, selectedStock, colorRadio.value);
              if (variantExists) {
                // Select this color radio button
                colorRadio.checked = true;
                noVariant = false;
                // Trigger change event to update product
                colorRadio.dispatchEvent(new Event('change'));
                break;
              }
            }
          }
          if (noVariant) {
            //Try to change the availability
            const otherStock = document.querySelector('input[name="Availability"]:not(checked)');
            otherStock.checked = true
            otherStock.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }
  
  function checkVariantExists(variants,size,stock,color) {
    // Check against your product variants
    if (size) {
      return variants.some(variant => 
            variant.option1 === size && variant.option2 === stock && variant.option3 === color && variant.available
          );

    } else {
return variants.some(variant => 
            variant.option1 === stock && variant.option2 === color && variant.available
          );
    }
  }

  //handle accordion behaviour
   var accordionTitles = document.querySelectorAll('.accordion-title');

        accordionTitles.forEach(function (title) {
            title.addEventListener('click', function () {
                var content = this.nextElementSibling;
                var arrow = this.querySelector('.product-about__more-link');

                if (content.style.display === 'none' || content.style.display === '') {
                    content.style.display = 'block';
                    arrow.classList.add('up-arrow');
                } else {
                    content.style.display = 'none';
                    arrow.classList.remove('up-arrow');
                }
            });
        });



});


})();
